import React, { useEffect } from "react";
import { useAuth } from "../Context/AuthContext/Index";
import { useNavigate } from "react-router-dom";

const ProtectedLogin: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserLoggedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserLoggedIn) {
      navigate("/");
    }
  }, [isUserLoggedIn, navigate]);

  return <>{!isUserLoggedIn ? children : null}</>;
};

export default ProtectedLogin;
